import React from 'react';
import { useRequest } from 'ahooks';
import { executeQueryGetAuth } from 'app/utils/api';
import { Callout, Intent, Spinner } from '@blueprintjs/core';
import ReactTable from 'react-table';
// props requires targetUserID
export default function SingleUserLPView(props) {
    function loadActivity() {
        return new Promise((resolve, reject) => {
            try {
                executeQueryGetAuth(`data/lj/user/${props.targetUserID}`, {}, props.user, (data) => {
                    resolve(JSON.parse(data.text));
                });
            }
            catch (err) {
                reject(err);
            }
        });

    }

    const { data, error, loading } = useRequest(loadActivity);

    if (loading) {
        return <Spinner />
    }

    if (error) {
        return <Callout intent={Intent.DANGER} >
            <p>{JSON.stringify(error)}</p>
        </Callout>
    }

    const columns = [
        {
            Header: "Journal Date",
            accessor: "created",
            Cell: (props) => {
                if (props.value === undefined) {
                    return <span />
                }
                return <p>{props.value}</p>
            }
        },
        {
            Header: "Journal",
            accessor: "journal"
        },
        {
            Header: "Prompt",
            accessor: "prompt",
            Cell: (props) => {
                return <p>{props.value}</p>
            }
        }
    ]

    return <div style={{marginBottom: '20px'}}>
        <ReactTable
            className={"minimal-overview-table coaching-activity-table"}
            //@ts-ignore
            data={data} pageSize={data.length} showPageSizeOptions={false} showPagination={false} sortable={false} columns={columns} />
    </div>
}
